import { useEffect, useState } from "react";
import axios from "axios";
import { Users, Mail, Image, X, Send } from "lucide-react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./NosClients.css";

const API_URL = `${process.env.REACT_APP_API_URL}/api/client`;

const ClientList = () => {
  const [clients, setClients] = useState([]);
  const [showMailModal, setShowMailModal] = useState(false);
  const [mailContent, setMailContent] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [subject, setSubject] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  // ------- React Quill Toolbar -------
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ align: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "align",
    "list",
    "bullet",
    "link",
    "image",
  ];

  // ------- Fetch clients -------
  const fetchClients = async () => {
    try {
      const response = await axios.get(`${API_URL}/with-stats`);
      setClients(response.data);
    } catch (err) {
      console.error("Erreur récupération clients", err);
    }
  };

  // ------- Send email to all clients -------
  const sendEmailToAll = async () => {
    if (!subject.trim() || !mailContent.trim()) {
      setErrorMsg("⛔ Objet et message sont obligatoires !");
      return;
    }

    try {
      setLoading(true);
      setErrorMsg("");

      const formData = new FormData();
      formData.append("subject", subject);
      formData.append("message", mailContent);
      if (imageFile) formData.append("image", imageFile);

      const response = await axios.post(
        `${API_URL}/send-email-all`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      // ✅ SUCCESS
      alert(response.data.message || "Email envoyé avec succès !");

      // Reset
      setShowMailModal(false);
      setMailContent("");
      setImageFile(null);
      setSubject("");

    } catch (err) {
      console.error(err);
      setErrorMsg("❌ Erreur lors de l’envoi des emails.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  return (
    <div className="container">
      <h2 className="title">
        <Users className="mr-2" /> Gestion des Clients & Fidélisation
      </h2>

      <button className="send-all-btn" onClick={() => setShowMailModal(true)}>
        <Mail className="mr-2" /> Envoyer un email à tous
      </button>

      {/* ============== LISTE CLIENTS ============== */}
      <div className="client-list">
        <div className="client-header">
          <span>Nom</span>
          <span>Email</span>
          <span>Téléphone</span>
          <span>Réservations</span>
          <span>Total Payé</span>
        </div>

        {clients.map((client, index) => (
          <div key={index} className="client-item">
            <strong>
              {client.nom} {client.prenom}
            </strong>
            <span>{client.email}</span>
            <span>{client.telephone}</span>
            <span>{client.totalReservations}</span>
            <span>{client.totalPaid} DA</span>
          </div>
        ))}
      </div>

      {/* ============== MODAL EMAIL TYPE GMAIL ============== */}
      {showMailModal && (
        <div className="modal-overlay">
          <div className="modal gmail-style bottom-right">

            {/* Header */}
            <div className="modal-header">
              <h3>Nouveau message</h3>
              <button
                className="close-icon"
                onClick={() => setShowMailModal(false)}
              >
                <X size={18} />
              </button>
            </div>

            {/* Erreur */}
            {errorMsg && <p className="error-msg">{errorMsg}</p>}

            {/* Objet */}
            <input
              type="text"
              placeholder="Objet"
              className="subject-input"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />

            {/* Editeur type Gmail */}
            <ReactQuill
              theme="snow"
              value={mailContent}
              onChange={setMailContent}
              modules={modules}
              formats={formats}
              placeholder="Écrivez votre message ici..."
              className="quill-editor"
            />

            {/* Pièce jointe */}
            <label className="upload-label">
              <Image size={18} />
              Ajouter une image
              <input
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
                hidden
              />
            </label>

            {imageFile && (
              <p className="preview-text">
                📎 {imageFile.name}
              </p>
            )}

            {/* Boutons */}
            <div className="modal-actions">
              <button
                className="send-btn"
                onClick={sendEmailToAll}
                disabled={loading}
              >
                <Send size={16} />
                {loading ? " Envoi..." : " Envoyer"}
              </button>

              <button
                className="close-btn"
                onClick={() => setShowMailModal(false)}
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default ClientList;
